import screenfull from 'screenfull'

export function fullScreen() {
  if (this.isFullscreen) {
    screenfull.exit()
    this.isFullscreen = false
  } else {
    screenfull.request()
    this.isFullscreen = true
  }
}
export function minusValue(minus, val, setp) {
  if (minus === '+') {
    return (val += setp)
  } else if (minus === '-') {
    return (val -= setp)
  }
}

export function setCanvasSize(
  father = document.getElementById('scenes'),
  child = document.getElementById('therapy-canvas')
) {
  if (father === null) {
    return
  }
  let w = (child.width = father.clientWidth)
  let h = (child.height = father.clientHeight - 48)

  setGlobalSize({ w, h })
  return { w, h }
}

function setGlobalSize({ w, h }) {
  window.gameWidth = w
  window.gameHeight = h
}

export function handleResize() {
  const [stageHeight, stageWidth] = [
    $('#scenes-container').height(),
    $('#scenes-container').width(),
  ]
  const aspectRatio = stageWidth / stageHeight
  const PROPORTION = 1280 / 720

  if (aspectRatio > PROPORTION) {
    // 舞台 宽高比 大于 比例尺
    // 则 高适应
    $('#therapy-canvas').css({ width: 'auto', height: '100%' })
  } else {
    // 舞台 宽高比 小于 比例尺
    // 则 宽适应
    $('#therapy-canvas').css({ width: '100%', height: 'auto' })
  }
}

export function regsitTherapyMoudle({ store }, settingConfig) {
  for (let i = 0; i < settingConfig.length; i++) {
    const element = settingConfig[i]
    store.registerModule(['therapy', Object.keys(element)], element)
  }
}

export class CountDown {
  constructor(config) {
    this.duration = config.duration
    this.callback = config.callback
    this.termination = false
    this.current = 0
  }

  update(dt) {
    if (this.termination) {
      return
    }
    this.current += dt
    if (this.current > this.duration) {
      this.termination = true
      this.callback()
    }
  }

  getRemain() {
    return Math.ceil((this.duration - this.current) * 0.001)
  }
}
